import { Controller } from "@hotwired/stimulus";

export default class TurboFormRequestController extends Controller {

  connect() {

    this.element.addEventListener(
      "turbo:before-fetch-request",
      this.addTurboStreamHeaders
    );

  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-fetch-request",
      this.addTurboStreamHeaders
    );
  }

  addTurboStreamHeaders(event) {
    const { headers } = event.detail.fetchOptions || {};

    if (headers) {
      headers.Accept = ["text/vnd.turbo-stream.html", headers.Accept].join(", ");
    }
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
      const cleanURL = location.protocol + "//" + location.host + location.pathname;
      history.replaceState({}, document.title, cleanURL);
    }, 200);
  }
}
